import type { EventMediaItem } from "@/lib/events/types"

/**
 * `EventMediaItem.createdAt` is typed as Date, but JSON responses and some
 * client caches leave ISO strings. Normalize before sorting or formatting.
 */
export function eventMediaCreatedAtDate(
  createdAt: EventMediaItem["createdAt"] | string,
): Date {
  return createdAt instanceof Date ? createdAt : new Date(createdAt)
}

export function eventMediaCreatedAtMs(
  createdAt: EventMediaItem["createdAt"] | string,
): number {
  return eventMediaCreatedAtDate(createdAt).getTime()
}
